import * as React from 'react';

const DemoWrapper = ({ children }) => {
  return (
    <div className="demo-wrapper" style={{ padding: '12px 24px' }}>
      {children}
    </div>
  );
};

export default DemoWrapper;
